import SegmentedToggle from "components/shared/SegmentedToggle";

type RotationValue = 0 | 45 | 90;

interface XLabelRotationSelectorProps {
  value?: RotationValue;
  onChange?: (value: RotationValue) => void;
}

const OPTIONS = [
  { label: "0°", value: 0 },
  { label: "45°", value: 45 },
  { label: "90°", value: 90 }
];

export default function XLabelRotationSelector({
  value,
  onChange
}: XLabelRotationSelectorProps) {
  return (
    <SegmentedToggle
      value={value ?? 0}
      options={OPTIONS}
      onChange={(v) => onChange?.(v as RotationValue)}
      block
    />
  );
}
